import type { HTMLAttributes, ReactNode } from "react";

export interface KeyValueRow {
  label: ReactNode;
  value: ReactNode;
}

export interface KeyValueProps extends Omit<
  HTMLAttributes<HTMLDListElement>,
  "children"
> {
  rows: KeyValueRow[];
}

export function KeyValue({ className, rows, ...props }: KeyValueProps) {
  const classes = ["marker-key-value"];
  if (className) {
    classes.push(className);
  }

  return (
    <dl className={classes.join(" ")} {...props}>
      {rows.map((row, index) => (
        <div className="marker-key-value__row" key={index}>
          <dt>{row.label}</dt>
          <dd>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
